import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImageModalPage } from './image-modal';
import { PinchZoomModule } from 'ngx-pinch-zoom';

@NgModule({
  declarations: [
    ImageModalPage,
  ],
  imports: [
    IonicPageModule.forChild(ImageModalPage),
    PinchZoomModule 
  ],
})
export class ImageModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/image-modal/image-modal.module.ts